import React from 'react'
import { InputFileProps } from '../../types/components/inputFile'
import * as S from './style'

export const InputFile: InputFileProps = ({ file, setFile }) => {
  return (
    <S.Container>
      <p>* Arquivo do Currículo (Faça o upload apenas de aquivos .pdf de no máximo 5MB)</p>
      {file === null ? (
        <S.ButtonFile>
          <label htmlFor="files">Escolher Arquivo</label>
          <input
            id="files"
            name="files"
            type="file"
            accept="application/pdf"
            onChange={e => setFile(e.target.files && e.target.files[0])}
          />
        </S.ButtonFile>
      ) : (
        <S.ButtonFile>
          <p>{file.name}</p>
          <button
            onClick={() => {
              setFile(null)
            }}
          >
            Remover
          </button>
        </S.ButtonFile>
      )}
    </S.Container>
  )
}
